import loadable from '@loadable/component';
import React from 'react';

import Spin from '../../spin/spin';

export const RobotCodeLightLoadable = loadable(
    () => import(/* webpackChunkName: "robot-light" */ './robot__code-light'),
    { fallback: <Spin center delay /> }
);
